var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Filter component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconFilter extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.18762 1.51204C1.31617 1.26224 1.57355 1.10522 1.85449 1.10522H22.1445C22.4254 1.10522 22.6828 1.26224 22.8114 1.51204C22.9399 1.76184 22.9181 2.06254 22.7548 2.29115L15.0906 13.021V19.0237C15.0906 19.2745 14.9653 19.5086 14.7567 19.6477L10.0744 22.7693C9.84422 22.9227 9.54832 22.937 9.30445 22.8065C9.06058 22.676 8.90834 22.4218 8.90834 22.1452V13.021L1.24419 2.29115C1.0809 2.06254 1.05907 1.76184 1.18762 1.51204ZM3.31189 2.60522L10.2686 12.3447C10.3595 12.4719 10.4083 12.6243 10.4083 12.7806V20.7438L13.5906 18.6223V12.7806C13.5906 12.6243 13.6395 12.4719 13.7303 12.3447L20.6871 2.60522H3.31189Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconFilter.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilter.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconFilter.prototype, "size", void 0);
if (customElements.get('cat-icon-filter') === undefined) {
    customElements.define('cat-icon-filter', BlocksIconFilter);
}
